import {lazy, Suspense} from "react";
// components
import LoadingScreen from "../components/loading-screen";
// ----------------------------------------------------------------------

const Loadable = (Component) => (props) =>
    (
        <Suspense fallback={<LoadingScreen/>}>
            <Component {...props} />
        </Suspense>
    );

// ----------------------------------------------------------------------

// AUTHENTICATION
export const Login = Loadable(lazy(() => import("../pages/auth/LoginPage")));

// PAGES
export const HomePage = Loadable(lazy(() => import("../pages/Home")));
export const StationServicesPage = Loadable(lazy(() => import("../pages/StationServices")));
export const ReportsPage = Loadable(lazy(() => import("../pages/ReportNew")));
export const InvoicePage = Loadable(lazy(() => import("../pages/Invoices")));

// ITEMS
export const ItemsPage = Loadable(lazy(() => import("../pages/Items")));
export const ItemsNewPage = Loadable(lazy(() => import("../pages/Items/ItemsNew")));
export const ItemsEditPage = Loadable(lazy(() => import("../pages/Items/ItemsEdit")));

// DISCOUNTS
export const DiscountsList = Loadable(lazy(() => import("../pages/Discounts")));
export const DiscountsNew = Loadable(lazy(() => import("../pages/Discounts/DiscountsNew")));
export const DiscountsEditPage = Loadable(lazy(() => import("../pages/Discounts/DiscountEditPage")));

// BUS
export const BusList = Loadable(lazy(() => import("../pages/Bus")));
export const BusNew = Loadable(lazy(() => import("../pages/Bus/BusNew")));
export const BusEditPage = Loadable(lazy(() => import("../pages/Bus/BusEditPage")));

// PRICE LIST
export const PriceList = Loadable(lazy(() => import("../pages/PriceList")));
export const PriceStationsList = Loadable(lazy(() => import("../pages/PriceList/PriceStationsList")));
export const PriceListNew = Loadable(lazy(() => import("../pages/PriceList/PriceListNew")));
export const PriceListStationNew = Loadable(lazy(() => import("../pages/PriceList/PriceStationsList/PriceListStationNew")));
export const PriceListEditPage = Loadable(lazy(() => import("../pages/PriceList/PriceListEditPage")));
export const PriceListStationEditPage = Loadable(lazy(() => import("../pages/PriceList/PriceStationsList/PriceListStationEditPage")));

// STATION LIST
export const StationList = Loadable(lazy(() => import("../pages/Stations")));
export const StationListNew = Loadable(lazy(() => import("../pages/Stations/StationListNew")));
export const StationListEditPage = Loadable(lazy(() => import("../pages/Stations/StationListEditPage")));

// LOCATIONS LIST
export const LocationsList = Loadable(lazy(() => import("../pages/Locations")));
export const LocationsListNew = Loadable(lazy(() => import("../pages/Locations/LocationsListNew")));
export const LocationsListEditPage = Loadable(lazy(() => import("../pages/Locations/LocationsListEditPage")));

// LINES LIST
export const LinesList = Loadable(lazy(() => import("../pages/Lines")));
export const LinesListNew = Loadable(lazy(() => import("../pages/Lines/LinesListNew")));
export const LinesListEditPage = Loadable(lazy(() => import("../pages/Lines/LinesListEditPage")));

// DEPARTURES LIST
export const DeparturesList = Loadable(lazy(() => import("../pages/Departures")));
export const DeparturesListNew = Loadable(lazy(() => import("../pages/Departures/DeparturesListNew")));
export const DeparturesListEditPage = Loadable(lazy(() => import("../pages/Departures/DeparturesListEditPage")));

// TIMES LIST
export const TimesList = Loadable(lazy(() => import("../pages/Times")));
export const TimesListNew = Loadable(lazy(() => import("../pages/Times/TimesListNew")));
export const TimesListEditPage = Loadable(lazy(() => import("../pages/Times/TimesListEditPage")));

// MONTHLY LIST
export const MonthlyTicketsList = Loadable(lazy(() => import("../pages/MonthlyTickets")));
export const MonthlyTicketsListNew = Loadable(lazy(() => import("../pages/MonthlyTickets/MonthlyTicketsNew")));
export const MonthlyTicketsListEditPage = Loadable(lazy(() => import("../pages/MonthlyTickets/MonthlyTicketsListEditPage")));

// CUSTOMERS
export const CustomersList = Loadable(lazy(() => import('../pages/Customers/CustomersList')))
export const CustomersNew = Loadable(lazy(() => import('../pages/Customers/CustomersNew')))
export const CustomersEditPage = Loadable(lazy(() => import('../pages/Customers/CustomersEditPage')))

// CARRIERS
export const CarriersList = Loadable(lazy(() => import('../pages/Carriers/CarriersList')))
export const CarriersNew = Loadable(lazy(() => import('../pages/Carriers/CarriersNew')))
export const CarriersEditPage = Loadable(lazy(() => import('../pages/Carriers/CarriersEditPage')))

// INSURANCE
export const InsuranceList = Loadable(lazy(() => import('../pages/Insurance/InsuranceList')))
export const InsuranceNew = Loadable(lazy(() => import('../pages/Insurance/InsuranceNew')))
export const InsuranceEditPage = Loadable(lazy(() => import('../pages/Insurance/InsuranceEditPage')))

// SERVICES
export const ServicesList = Loadable(lazy(() => import('../pages/Services')))
export const ServicesNew = Loadable(lazy(() => import('../pages/Services/ServiceNew')))
export const ServicesEditPage = Loadable(lazy(() => import('../pages/Services/ServicesEditPage')))

// SETTINGS
export const SettingsPage = Loadable(lazy(() => import("../pages/Settings")));
